import React, { useMemo } from 'react';
import { PhotoGalleryProps } from './PhotoGallery.types';
import { WebsiteEditorPhotoGalleryTelemetryProvider } from './PhotoGallery.telemetry';
import { CustomComponentsWrapperType } from '@website-editor/customComponents';
import { useAddPhotoGalleryNavigations } from './hooks/useAddPhotoGalleryNavigation';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { PhotoGalleryEditListItem } from './wrappers/PhotoGalleryEditListItem/PhotoGalleryEditListItem';

// Lazy load sub-components
const PhotoGalleryAddListItem = loadable(
  () => import(/* webpackChunkName: "content/websiteEditorPhotoGalleryAddListItem" */ './wrappers/PhotoGalleryAddListItem/PhotoGalleryAddListItem'),
  'PhotoGalleryAddListItem',
);

const SelectPhotoGallery = loadable(() => import(/* webpackChunkName: "content/websiteEditorSelectPhotoGallery" */ './components'), 'SelectPhotoGallery');

export const PhotoGallery: React.FC<PhotoGalleryProps> = props => {
  const { wrapperType, componentData, ...restProps } = props;

  useAddPhotoGalleryNavigations(props);

  const getRenderComponent = useMemo(() => {
    switch (wrapperType) {
      case CustomComponentsWrapperType.AddComponentList:
        return (
          <PhotoGalleryAddListItem
            {...restProps}
            componentData={componentData}
          />
        );
      case CustomComponentsWrapperType.EditComponentList:
        return (
          <PhotoGalleryEditListItem
            {...restProps}
            componentData={componentData}
          />
        );
      default:
        return (
          <SelectPhotoGallery
            {...restProps}
            isEditMode
            isSingleComponent
          />
        );
    }
  }, [componentData, restProps, wrapperType]);

  return <WebsiteEditorPhotoGalleryTelemetryProvider>{getRenderComponent}</WebsiteEditorPhotoGalleryTelemetryProvider>;
};

PhotoGallery.displayName = 'PhotoGallery';
